import Vue from 'vue'
import Vuex from 'vuex'
import rp from "request-promise-native"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    message: "This is a test",
    username: "",
    password: "",
    confirmedPassword: "",
    token: "",
    name: "",
    signedUp: false,
    cars: [],
    newCar: {
      name: "",
      make: "",
      model: "",
      year: 0,
      mileage: 0,
      vin: ""
    },
    selectedCar: {},
    mpgEntry: {
      gallons: 0,
      miles: 0,
      price: 0,
      type: "",
      location: {
        latitude: 0,
        longitude: 0
      }
    },
    nav: false,
    navItems: [
      {
        title: "Home",
        icon: "fas fa-home",
        link: "/"
      },
      {
        title: "Profile",
        icon: "fas fa-user-circle",
        link: "/profile"
      },
      {
        title: "Cars",
        icon: "fas fa-car",
        link: "/dashboard"
      },
      {
        title: "MPGs",
        icon: "fas fa-gas-pump",
        link: "/mpgs"
      }
    ],
    loadingDialog: false,
    errorAlert: false
  },
  mutations: {
    setNav(state, val) {
      state.nav = val;
    },
    setUsername (state, data) {
      state.username = data;
    },
    clearUsername(state) {
      state.username = "";
    },
    setPassword (state, data) {
      state.password = data;
    },
    clearPassword (state) {
      state.password = "";
    },
    setSignedUp(state) {
      state.signedUp = true;
    },
    clearSignedUp(state) {
      state.signedUp = false;
    },
    setConfirmedPassword(state, data) {
      state.confirmedPassword = data
    },
    clearConfirmedPassword(state) {
      state.confirmedPassword = "";
    },
    setToken (state, data) {
      state.token = data;
    },
    clearToken(state) {
      state.token = "";
    },
    setName(state, name) {
      state.name = name;
    },
    clearName(state) {
      state.name = "";
    },
    setCars(state, cars) {
      state.cars = cars;
    },
    clearCars(state) {
      state.cars = [];
    },
    setSelectedCar(state, car) {
      state.selectedCar = car;
    },
    clearSelectedCar(state) {
      state.selectedCar = {};
    },
    setLocation(state, coords) {      
      // TODO: Temporarily setting this to near Mobile:
      // const testLat = 34.6899317;
      // const testLong = -118.1663136;
      // state.mpgEntry.location.latitude = testLat;
      // state.mpgEntry.location.longitude = testLong;
      state.mpgEntry.location.latitude = coords.latitude;
      state.mpgEntry.location.longitude = coords.longitude;
    },
    clearLocation(state) {
      state.mpgEntry.location.latitude = 0;
      state.mpgEntry.location.longitude = 0;
    },
    clearMpgEntry(state) {
      state.mpgEntry = {
        gallons: 0,
        miles: 0,
        price: 0,
        location: {
          latitude: 0,
          longitude: 0
        }
      }
    },
    setMiles(state, val) {
      state.mpgEntry.miles = val;
    },
    clearMiles(state) {
      state.mpgEntry.miles = 0;
    },
    setGallons(state, val) {
      state.mpgEntry.gallons = val;
    },
    clearGallons(state) {
      state.mpgEntry.gallons = 0;
    },
    setPrice(state, val) {
      state.mpgEntry.price = val;
    },
    clearPrice(state) {
      state.mpgEntry.price = 0;
    },
    setType(state, data) {
      state.mpgEntry.type = data;
    },
    clearType(state) {
      state.mpgEntry.type = "";
    },
    setCar(state, name, make, model, year, mileage, vin) {
      state.newCar = {
        name,
        make,
        model,
        year,
        mileage,
        vin
      }
    },
    clearNewCar(state) {
      state.newCar = {};
    },
    replaceCarInCars(state, car) {
      // Find the car
      const index = state.cars.findIndex(item => {
        return item._id === car._id;
      });
      // Replace the car
      state.cars[index] = car;
    },
    logOut(state) {
      state.username = "";
      state.name = "";
      state.cars = [];
      state.signedUp = false;
    },
    showLoadingDialog(state) {
      state.loadingDialog = true;
    },
    hideLoadingDialog(state) {
      state.loadingDialog = false;
    },
    showErrorAlert(state) {
      state.errorAlert = true;
    },
    hideErrorAlert(state) {
      state.errorAlert = false;
    }
  },
  getters: {
    getCarNames(state) {
      return state.cars.map(car => {
        let c = {
          name: car.name,
          id: car._id
        };
        return c;
      });
    },
    getSpecificCar(state) {
      return (id) => {
        const result = state.cars.filter(item => item._id === id);        
        return result[0];
      }
    }
  },
  actions: {
    async loadCars({commit}, token) {
      let options = {
        method: "GET",
        uri: `${process.env.VUE_APP_HOST}/cars`,
        auth: {
          bearer: token
        },
        json: true
      };

      try {         
          commit("setCars", await rp(options))
      } catch (e) {
          console.log(e);
      }
    },
    async getLocation({ commit }) {
      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition((results) => {
          commit("setLocation", results.coords);
          resolve(true);
        })
      })
    },
    // async saveMpgEntry({ commit }, token, id) {
    //   // Options for request-promise-native
    //   let options = {
    //     method: "POST",
    //     uri: `http://localhost:3000/cars/${id}/mpg`,
    //     auth: {
    //       bearer: token
    //     },
    //     json: true
    //   }

    //   try {
    //     await rp(options);
    //   } catch (e) {
    //       return new Error (e);
    //   }
    // }
  },
  modules: {
  }
})
